/**
 * @param {jQuery} $ jQuery object.
 * @param {Astoundify} Astoundify Astoundify object.
 */
(function( $, Astoundify ) {

	/**
	 * Checkout
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var self = Astoundify.Checkout || {};

	/**
	 * Update the cart status icon when an item is added or removed.
	 *
	 * @since 1.6.0
	 *
	 * @param total
	 */
	var updateCartStatus = function( total ) {
		$( '.account-info-cart-alert' ).toggle( 0 != total );
	};

	/**
	 * Watch the billing country field.
	 *
	 * Hide billing address by default unless the country is switched
	 * to Canada. Taxes! Miss Mullin, you're the man.
	 *
	 * @since 1.2.0
	 * 
	 * @param {string} gateway
	 */
	self.watchBillingCountry = function( gateway ) {
		var hiddenFields = [
			$( '#edd-card-address-wrap' ),
			$( '#edd-card-address-2-wrap' ),
			$( '#edd-card-city-wrap' ),
			$( '#edd-card-zip-wrap' ),
			$( '#edd-card-state-wrap' )
		];

		$.each(hiddenFields, function() {
			$(this).children( 'input' ).val( '' );
			$(this).hide();
		});

		var $country = $( '#edd-card-country-wrap' ).detach();
		$country.prependTo( '#edd_cc_address' );

		$country.find( 'select' ).on( 'change', function() {
			var isCa = 'CA' === $(this).val();

			$.each(hiddenFields, function() {
				$(this).toggle( isCa );
			});
		});

		$country.find( 'select' ).trigger( 'change' );
	};

	/**
	 * Arrange fields.
	 *
	 * @since 1.0.0
	 */
	self.arrangeFields = function( gateway ) {
		self.watchBillingCountry( gateway );

		// move email
		$( '#edd-email-wrap' ).detach().insertAfter( '#edd-last-name-wrap' );

		// move name
		$( '#edd-card-name-wrap' ).detach().insertAfter( '#edd_cc_fields' );

		// add a lock icon
		$( '#edd_cc_fields legend' ).append( '<i class="icon--lock graphic--lock"></i><span class="screen-reader-text">Secure Checkout</span>' );

		// move renewals
		$( '#edd_sl_renewal_form' ).detach().insertAfter( '#edd_payment_mode_select' );
	};

	/**
	 * Arrange renewals.
	 *
	 * @since 1.0.0
	 */
	self.arrangeRenewals = function() {
		if ( $( '#edd_sl_renewal_form' ).find( '.edd_errors' ).length > 0 ) {
			$( '#edd_sl_renewal_form' ).addClass( 'edd_sl_renewal_form--is-open' );
			$( '#edd_sl_show_renewal_form_wrap' ).hide();
			$( '#edd-license-key-container-wrap' ).show();
			$( '.edd-sl-renewal-actions' ).show();
		}
	};

	/**
	 * Bind actions to DOM ready.
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {
		// discount link toggle class
		$( '.edd_discount_link' ).on( 'click', function(e) {
			e.preventDefault();

			$(this).parents( '#edd_discount_code' ).toggleClass( 'edd_discount_code--is-open' );
		});

		$( '#edd_sl_show_renewal_form' ).on( 'click', function(e) {
			e.preventDefault();

			$(this).parents( '#edd_sl_renewal_form' ).toggleClass( 'edd_sl_renewal_form--is-open' );
		});

		// rearrange some billing
		self.arrangeFields( 'stripe' );
		self.arrangeRenewals();

		$( 'body' ).on( 'edd_gateway_loaded', function( e, gateway ) {
			self.arrangeFields( gateway );
			self.arrangeRenewals();
		});

		$( 'body' ).on( 'edd_taxes_recalculated', function( event, tax_data ) {
			$( '.edd_cart_tax_amount' ).text( '$' + tax_data.response.tax_raw );
			$( '.edd_cart_amount' ).text( '$' + tax_data.response.total_raw );
			$( '.edd_cart_amount' ).data( 'total', tax_data.response.total_raw );

			$( '.edd_cart_tax_row' ).toggle( 0.00 != tax_data.response.tax_raw );
		});

		// Wrap selects.
		$( 'body' ).on( 'edd_gateway_loaded', function() {
			Astoundify.Select.wrap();
		});

		// Watch cart additions and removals.
		$( 'body' ).on( 'edd_cart_item_removed', function( event, data ) {
			updateCartStatus( data.cart_quantity );
		} );

		$( 'body' ).on( 'edd_cart_item_added', function( event, data ) {
			updateCartStatus( data.cart_quantity );
		} );
	});

})( jQuery, Astoundify );
